module.exports = __webpack_public_path__ + "static/separator 1-9966ff06ce20fc99c0be4c21bde4237d.svg";